import { render, staticRenderFns } from "./PropagandistList.vue?vue&type=template&id=48269876&"
import script from "./PropagandistList.vue?vue&type=script&lang=js&"
export * from "./PropagandistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports